<template>
  <v-card
    height="100%"
    :disabled="disabled"
    v-bind:style="{
      backgroundColor: selected ? '#F1FAFA' : null
    }"
    :class="{ 'border--accent': selected }"
  >
    <v-row class="plan-header secondarytext--text overflow-hidden mx-0">
      <v-col cols="12" class="pt-10 px-6 pb-4">
        <v-spacer></v-spacer>
        <v-icon class="float-right" v-if="selected" color="accent">
          check_circle
        </v-icon>
        <h1 class="secondary--text">{{ plan.name }}</h1>
        <div class="subtitle-1 pb-4">
          {{ getCompanyPlanTypeSubTitle(planId) }}
        </div>
        <div>
          <span class="text-h5 font-weight-medium">
            ${{ this.plan.pricePerUser }}
          </span>
          per user/month
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="px-8">
        <v-btn
          :disabled="selected"
          outlined
          block
          :color="color"
          @click="selectPlan"
        >
          Choose {{ plan.name }}
        </v-btn>
      </v-col>
      <v-col cols="12" class="px-8">
        <bulleted-list
          :bullets="[
            { label: getCompanyPlanTypeAdditionalBullet(planId), value: ' ' }
          ]"
          :color="color"
          icon="add"
          v-if="getCompanyPlanTypeAdditionalBullet(planId)"
          class="transparent"
        >
        </bulleted-list>
        <bulleted-list
          :bullets="getCompanyPlanTypeBullets(planId)"
          :color="color"
          icon="done"
          class="transparent"
        >
        </bulleted-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import BulletedList from "@/components/common/BulletedList";
import companyPlanTypes from "@/helpers/mixins/companyPlanTypes";
export default {
  components: { BulletedList },
  name: "SelectPlanCard",
  mixins: [companyPlanTypes],
  props: {
    planId: { type: Number }
  },
  data: () => ({}),
  computed: {
    plan() {
      return this.company_plan_types.find(x => x.id == this.planId) || {};
    },
    color() {
      return "accent";
    },
    selected() {
      return this.planId == this.billing.planTypeId;
    },
    price() {
      return `$${this.plan.pricePerUser} per user/month`;
    },
    disabled() {
      switch (this.billing.planTypeId) {
        case this.$enums.companyPlanTypes.LITE:
          return this.planId == this.$enums.companyPlanTypes.SETUP;
        case this.$enums.companyPlanTypes.ENGAGEMENT:
          return (
            this.planId == this.$enums.companyPlanTypes.SETUP ||
            this.planId == this.$enums.companyPlanTypes.LITE
          );
      }
      return false;
    },
    ...mapGetters({
      company_plan_types: "lookup/company_plan_types",
      billing: "billing/billing"
    })
  },
  methods: {
    selectPlan() {
      switch (this.planId) {
        case this.$enums.companyPlanTypes.SETUP:
          this.$root.$alert(
            "Contact CoreCounts",
            "Please contact us at info@corecounts.com to cancel your account."
          );
          break;
        default:
          this.$emit("select", this.planId);
          break;
      }
    }
  }
};
</script>
